import { connect } from 'react-redux';
import { Map } from 'immutable';

// components
import Chapter from './Chapter';

import getOrganization from '../../../../lib/selectors/getOrganization';

const mapStateToProps = state => ({
  currentChapter: state.get('currentChapter') || Map(),
  organization:   getOrganization(state),
});

export default connect(mapStateToProps)(Chapter);
